import type { RadioTextFilterValueType } from '../GenericBloc/GenericRadioTextFilter/GenericRadioTextType';
import type { GenericOccurredOperation } from '../GenericConstants/GenericOccurredOptionList';

export enum SubFilterErrorKind {
  TEXT = 'text',
  PAGE_PATH = 'pagePath',
}

export interface ErrorType {
  operation: GenericOccurredOperation;
  subFilters: ErrorSubFilter[];
}

export interface ErrorSubFilter {
  id: string;
  kind: SubFilterErrorKind;
  value: RadioTextFilterValueType;
}
